import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { CircularProgress, Box } from '@mui/material';
import { ROUTES } from '../../constants/routes';
import { rolesID } from '../../constants/rolesID';
import { getCompany } from '../../store/company/actions';
import { getCurrentProfile, getCurrentUser } from '../../store/user/actions';
import { serviceLocalStorage } from '../../utils/serviceLocalStorage';
import { getCurrentUsersPermissions, getUserPermissions } from '../../store/user-permissions/actions';
import { useWebSocket } from '../../hooks/useWebSocket';

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const { data: wss } = useWebSocket();
  const { isAuth, fetching } = useSelector((state) => state.currentUser);

  const getPermissions = (data) => {
    dispatch(getCurrentUsersPermissions({ role: data.role.id, permissions: data.role.permissions }));
  };

  useEffect(() => {
    if (serviceLocalStorage.getUserID()) {
      dispatch(getCurrentUser(getPermissions));
      dispatch(getUserPermissions());

      if (+serviceLocalStorage.getUserRoleID() === rolesID.ROLE_ADMINISTRATOR) {
        dispatch(getCompany());
      }
    } // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (wss?.signal === 'update_role_permissions' && window.location.pathname !== ROUTES.USER_PERMISSIONS) {
      dispatch(getCurrentProfile(getPermissions));
      dispatch(getUserPermissions());
    } // eslint-disable-next-line
  }, [
    wss
  ]);

  return (
    <Route
      {...rest}
      render={(props) =>
        serviceLocalStorage.getUserID() || isAuth ? (
          fetching ? (
            <Box
              sx={{
                display: 'flex',
                height: '100vh',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
              <CircularProgress data-testid="CircularProgress" />
            </Box>
          ) : (
            <Component {...props} />
          )
        ) : (
          <Redirect to={{ pathname: ROUTES.LOGIN }} />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.any
};
